export const HumanDepartment = (to, from, next) => {
  return next()
}
